module.exports = __webpack_public_path__ + "img/likhaan-l.7c9092ec.png";